import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILeadTechnologyProfile, type IPrivateTechnology, leadTechnologyProfilesManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';

import { PRIVATE_TECHNOLOGY_MODULE } from '../private-technology-module';

export const UPDATE_LINK = 'updateLink';
export const OVERRIDE_EVALUATE = 'overrideEvaluate';

export const actions: ActionTree<ILeadTechnologyProfile, unknown> = {
    async [UPDATE_LINK](
        context,
        { profileId, directoryAssetId, properties }: { profileId: number; directoryAssetId?: number; properties?: string }
    ): Promise<void> {
        const updated = await leadTechnologyProfilesManager.updateLink(profileId, directoryAssetId, { properties });
        return context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [updated] });
    },
    async [OVERRIDE_EVALUATE](
        context,
        { profileId, evaluateId, oldId, properties }: { profileId: number; evaluateId: number; oldId?: number; properties?: string }
    ): Promise<void> {
        const updated = await leadTechnologyProfilesManager.overrideEvaluate(profileId, evaluateId, oldId, { properties });
        return context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [updated] });
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: ILeadTechnologyProfile[] }) {
        const leadTechnologyProfiles: ILeadTechnologyProfile[] = [];
        const assetEntities: IPrivateTechnology[] = [];

        dataObjectList.forEach((leadTechnologyProfile) => {
            const _leadTechnologyProfile = Object.assign({}, leadTechnologyProfile);

            if (isDataObject<IPrivateTechnology>(leadTechnologyProfile.assetEntity)) {
                const assetEntity = Object.assign({}, leadTechnologyProfile.assetEntity);
                _leadTechnologyProfile.assetEntity = assetEntity.dobjId;
                assetEntities.push(assetEntity);
            }

            leadTechnologyProfiles.push(_leadTechnologyProfile);
        });

        if (leadTechnologyProfiles.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: leadTechnologyProfiles });
        }
        if (assetEntities.length > 0) {
            void context.dispatch(`${PRIVATE_TECHNOLOGY_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: assetEntities }, { root: true });
        }
    }
};
